document.querySelectorAll('[data-faq]').forEach((section) => {
  const items = section.querySelectorAll('.faq__item');
  const singleOpen = section.dataset.singleOpen === 'true';

  items.forEach((item) => {
    const summary = item.querySelector('.faq__summary');
    if (!summary) return;

    summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');

    item.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');

      if (!singleOpen || !item.open) return;

      items.forEach((other) => {
        if (other !== item && other.open) {
          if (window.AccordionTransition) {
            window.AccordionTransition.close(other);
          } else {
            other.open = false;
          }
          const otherSummary = other.querySelector('.faq__summary');
          if (otherSummary) {
            otherSummary.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  });
});
